import { FieldCapturesPage } from '@/pages/inspection/field-captures/FieldCapturesPage';
import { createFileRoute } from '@tanstack/react-router';

function FieldCapturesRoute() {
	const { inspectionId } = Route.useParams();
	return <FieldCapturesPage inspectionId={inspectionId} />;
}

export const Route = createFileRoute('/_authenticated/_app/inspection/inspections/$inspectionId/captures')({
	component: FieldCapturesRoute,
});
